<template>
  <div>
    <div class="title">
      <div>{{ $t("RAM.TENCENT.REDIS.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:tencent:redisResource:update'
          ]"
          :loading="updateLoading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:tencent:redisResource:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <redis-resource-search ref="child"></redis-resource-search>
    <table-redis-resource></table-redis-resource>
  </div>
</template>

<script>
import RedisResourceSearch from "./RedisResourceSearch.vue";
import TableRedisResource from "./TableRedisResource.vue";
let tableRedisResource = TableRedisResource;

export default {
  name: "RedisResource",
  components: {
    RedisResourceSearch,
    TableRedisResource
  },
  data() {
    return {
      modal_loading: false,
      updateLoading: false
    };
  },
  methods: {
    update() {
      this.updateLoading = true;
      this.$api.resourceManagement
        .updateTencentResource({
          companyId: this.$refs.child.companyId,
          accountIdList: this.$refs.child.accountSearchKey,
          resourceManagement: 606,
          accountType: 6
        })
        .then(res => {
          this.updateLoading = false;
          this.$Message.success(this.$t("common.updateSuccess"));
          setTimeout(() => {
            tableRedisResource.methods.showAll();
          }, 1000);
        })
        .catch(() => {
          this.updateLoading = false;
          this.$Message.error(this.$t("common.updateFail"));
        });
    },
    exportList() {
      let exportDTO = {
        companyId: this.$refs.child.companyId,
        accountIdList: this.$refs.child.accountSearchKey,
        accountName: this.$refs.child.accountName,
        instanceId: this.$refs.child.instanceId
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t("common.exporting")
      });
      this.$api.resourceManagement.exportTencentRedis(exportDTO).then(res => {
        this.exportResponse(res);
      }).catch(() => {
        this.modal_loading = false;
        this.$Message.destroy();
        this.$Message.error(this.$t("common.exportFail"));
      });
    },
    exportResponse(res) {
      let fileName = this.$t("RAM.export.tencentRedis");
      let blob = new Blob([res.data], { type: "application/x-xls" });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
      this.modal_loading = false;
      this.$Message.destroy();
      this.$Message.success(this.$t("common.exportSuccess"));
    }
  }
};
</script>

<style scoped>
.title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.title > div:nth-child(1) {
  float: left;
}
.title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/tencent/redis/RedisResource.vue